export enum GammaAccuracy {
  Point = 110,
  Polygon = 120,
  MultiPolygon = 130,
  Organisation = 211,
  SubAddressPoint = 212,
  AddressPoint = 213,
  Building = 214,
  BuildingGroup = 221,
  Thoroughfare = 222,
  Postcode = 223,
  Locality = 224,
  PostTown = 225,
  County = 226,
  AddressNotMatched = 421,
}

export enum AccuracyDisplay {
  Low = "Low",
  High = "High",
}

export type GammaAccuracyDefinition = {
  name: string;
  description: string;
  accuracy: AccuracyDisplay;
};
